export interface SegmentRegel {
  segment: string;
  kriterier: string[];
}

/** Sammendrag av «Segmentdefinisjoner – bransje 234 Kjøkken» (15.09.2026). */
export const segmentRegler: SegmentRegel[] = [
  {
    segment: 'Sykehus',
    kriterier: [
      'Sykehus og RHF-eide/-drevne institusjoner.',
      'Behandlings-/rehabiliteringssentre med botilbud og avtale med et RHF (uansett diagnosegruppe).',
      'Botilbud uten bekreftet RHF-avtale er usikre – ikke anta Sykehus.',
    ],
  },
  {
    segment: 'Eldreomsorg',
    kriterier: [
      'Sykehjem, aldershjem, bo- og behandlingssentre for eldre, BOAS.',
      'Alt med «omsorgsbolig» i navnet.',
      'Alt med «seniorsenter» i navnet.',
      '«-tunet»-navn er som regel eldreomsorg, men verifiser (unntak: Gjestadtunet).',
      'Kommunale sentralkjøkken (Storkjøkken, Felleskjøkken, Kjøkkenteneste) for eldreomsorgen, helsehus og lokalmedisinske sentre med akuttplasser.',
      'Boliger for utviklingshemmede er IKKE eldreomsorg.',
    ],
  },
  {
    segment: 'Barnehage',
    kriterier: ['Ordinære barnehager og studentbarnehager (funksjon overstyrer eierskap).'],
  },
  {
    segment: 'Grunnskole',
    kriterier: [
      'Ordinære grunnskoler og alle leirskoler.',
      '«Helsestasjon»/«helsetjeneste» i navnet overstyrer «skole» → Øvrig institusjonsservering.',
    ],
  },
  {
    segment: 'Videregående/campus',
    kriterier: [
      'Videregående skoler.',
      'Kjøkken, catering og studenthus eid av en studentsamskipnad (SiT, SiÅs, SiO …), også på universitets-/høyskolenivå.',
      'Enheter under kjeden Sin innkjøp.',
      'Studentbarnehager er Barnehage, ikke Videregående/campus.',
    ],
  },
  { segment: 'Folkehøgskole', kriterier: ['Folkehøgskoler.'] },
  {
    segment: 'Øvrig institusjonsservering',
    kriterier: [
      'Standardforslag når ingen annen regel passer.',
      'Barnevern, bofellesskap/boliger for utviklingshemmede, arbeidstrening/VTA, asylmottak, fengsel, kantiner.',
    ],
  },
];
